import { call, put, all, takeEvery } from 'redux-saga/effects'

import {
  GET_RIGHTS,
  getRightsSuccess,
  getRightsFailure,
  GET_RIGHT,
  getRightSuccess,
  getRightFailure,
  CREATE_RIGHT,
  createRightSuccess,
  createRightFailure,
  UPDATE_RIGHT,
  updateRightSuccess,
  updateRightFailure,
  DELETE_RIGHT,
  deleteRightSuccess,
  deleteRightFailure,
  GET_RIGHT_SUGGESTED_CHANGES,
  getRightSuggestedChangesSuccess,
  getRightSuggestedChangesFailure,
  APPLY_RIGHT_SUGGESTED_CHANGES,
  applyRightSuggestedChangesSuccess,
  applyRightSuggestedChangesFailure,
  GET_PARTNERBRAIN_HISTORY,
  getPartnerbrainHistorySuccess,
  getPartnerbrainHistoryFailure,
  GET_RIGHT_SOCIAL_POSTS,
  getRightSocialPostsSuccess,
  getRightSocialPostsFailure
} from '../actions/rights'

import {
  getRightsService,
  getRightService,
  createRightService,
  updateRightService,
  deleteRightService,
  getRightSuggestedChangesService,
  applyRightSuggestedChangesService,
  getPartnerbrainHistoryService,
  getRightSocialPostsService
} from '../services/rights'

function* rightsWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(APPLY_RIGHT_SUGGESTED_CHANGES, applyRightSuggestedChangesWorker),
    takeEvery(GET_RIGHTS, getRightsListWorker),
    takeEvery(GET_RIGHT, getRightWorker),
    takeEvery(CREATE_RIGHT, createRightWorker),
    takeEvery(UPDATE_RIGHT, updateRightWorker),
    takeEvery(DELETE_RIGHT, deleteRightWorker),
    takeEvery(GET_RIGHT_SUGGESTED_CHANGES, getRightSuggestedChangesWorker),
    takeEvery(GET_PARTNERBRAIN_HISTORY, getPartnerbrainHistoryWorker),
    takeEvery(GET_RIGHT_SOCIAL_POSTS, getRightSocialPostsWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getRightsListWorker({ params }) {
  try {
    const rights = yield call(getRightsService, params)
    yield put(getRightsSuccess(rights))
  } catch (e) {
    yield put(getRightsFailure(e))
  }
}

function* getRightWorker({ id, getOptions }) {
  try {
    const { isAsyncMode } = getOptions

    const response = yield call(getRightService, id, isAsyncMode)
    yield put(getRightSuccess(response))
  } catch (e) {
    yield put(getRightFailure(e))
  }
}

function* createRightWorker({ rightData }) {
  try {
    const response = yield call(createRightService, rightData)
    yield put(createRightSuccess(response))
  } catch (e) {
    yield put(createRightFailure(e))
  }
}

function* updateRightWorker({ id, rightData, method }) {
  try {
    const response = yield call(updateRightService, id, rightData, method)
    yield put(updateRightSuccess(response))
  } catch (e) {
    yield put(updateRightFailure(e))
  }
}

function* deleteRightWorker({ id }) {
  try {
    yield call(deleteRightService, id)
    yield put(deleteRightSuccess(id))
  } catch (e) {
    yield put(deleteRightFailure(e))
  }
}

function* getRightSuggestedChangesWorker({ id }) {
  try {
    const response = yield call(getRightSuggestedChangesService, id)
    yield put(getRightSuggestedChangesSuccess(response))
  } catch (error) {
    yield put(getRightSuggestedChangesFailure(error))
  }
}

function* applyRightSuggestedChangesWorker({ id }) {
  try {
    const response = yield call(applyRightSuggestedChangesService, id)
    yield put(applyRightSuggestedChangesSuccess(response))
  } catch (error) {
    yield put(applyRightSuggestedChangesFailure(error))
  }
}

function* getPartnerbrainHistoryWorker({ params }) {
  try {
    const response = yield call(getPartnerbrainHistoryService, params)
    yield put(getPartnerbrainHistorySuccess(response))
  } catch (error) {
    yield put(getPartnerbrainHistoryFailure(error))
  }
}

function* getRightSocialPostsWorker({ params }) {
  try {
    const response = yield call(getRightSocialPostsService, params)
    yield put(getRightSocialPostsSuccess(response))
  } catch (error) {
    yield put(getRightSocialPostsFailure(error))
  }
}

export default rightsWatcher
